// extracted by mini-css-extract-plugin
export default {"home-item":"ComponentBreadCrumb_home-item__eDqKN"};